import { useCallback } from "react";
import useApi from "./useApi";
import useModal from "./useModal";
import locale from "localization";

const useExport = ({ api, reportType, mappedFilterState, hasModal }) => {
  const { request, loading } = useApi({ api, params: api.params });
  const successModalComponent = useModal();

  const exportReport = useCallback(
    async ({ fileType }) => {
      const filterState = {
        ...mappedFilterState,
        ...(fileType
          ? {
              fileType,
            }
          : {}),
        ...(hasModal ? { platformType: localStorage.getItem("platformType") } : {}),
      };
      delete filterState.page;
      delete filterState.perPage;

      const resp = await request({ ...filterState, reportType });
      if (hasModal) {
        //temporary
        successModalComponent.show({
          title: locale.exclamatedSuccess,
          content: locale.reportGenerated,
        });
      } else {
        window.open(resp?.downloadUrl, "_blank");
      }
    },
    [request, reportType, mappedFilterState, hasModal, successModalComponent]
  );

  return { exportReport, exporting: loading, successModalComponent };
};

export default useExport;
